import React from "react";
import { Link } from "react-router-dom";
import { getAllExperiences } from "../../lib/loadContent";

const Experience = () => {
  const experiences = getAllExperiences();

  return (
    <div className="page">
      <h1 className="page-title">experience/</h1>
      <p className="page-path">~/portfolio/experience/</p>

      <div className="experience-list">
        {experiences.map((e) => (
          <Link
            to={`/experience/${e.slug}`}
            key={e.slug}
            className="experience-card"
          >
            <div className="experience-card-head">
              <span className="experience-card-title">{e.title}</span>
              <span className="experience-card-company">{e.company}</span>
              <span className="experience-card-date">{e.date}</span>
            </div>
            <div className="experience-tags">
              {e.tags.map((t) => (
                <span key={t} className="tag">
                  {t}
                </span>
              ))}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Experience;